import type { CrossJoinTargetProduct } from '../../common/types';
import type { PermsApiResponse } from '../types';

export const hasAccessToProduct = async (
	product: CrossJoinTargetProduct,
	cloudId: string,
): Promise<boolean> => {
	const data = {
		permissionId: 'write',
		resourceId: `ari:cloud:${product}::site/${cloudId}`,
	};
	const response = await fetch('/gateway/api/permissions/permitted', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(data),
	});

	return ((await response.json()) as unknown as PermsApiResponse).permitted;
};
